import React from 'react';
import { SectionHeading, SpecSection } from './SectionHeading';
import { SummonDemo } from './SummonDemo';
import { LiveDataDemo } from './LiveDataDemo';
import { motionPrinciples, motionTokens } from '../../data/motion';
export function MotionSection() {
  return <SpecSection id="beweging" data-id="element-1097" data-mp="1kl6fp3vdrajg">
      <SectionHeading id="beweging" index={3} title="Bewegingstaal" intro="Leven en diepte, geen neon-kitsch. Alles beweegt met een reden, en die reden is altijd een toestand, aandacht of voortgang." data-id="element-1098" data-mp="1oknpg9huatuf" />

      <div className="mt-14 grid gap-12 lg:grid-cols-12" data-id="element-1099" data-mp="1ygqsdhkimwif">
        <ol className="space-y-7 lg:col-span-4" data-id="element-1100" data-mp="2391r4h3isc9e">
          {motionPrinciples.map(p => <li key={p.title} data-id="element-1101" data-mp="288wjkp2y19wk">
              <h3 className="text-[17px] font-semibold text-ink" data-id="element-1102" data-mp="287v5scujm9b5">{p.title}</h3>
              <p className="mt-1.5 text-[15px] leading-relaxed text-ink-soft" data-id="element-1103" data-mp="2cb18xbmczkde">{p.body}</p>
            </li>)}
        </ol>
        <div className="lg:col-span-8" data-id="element-1104" data-mp="2h9cj5ngkfww5">
          <SummonDemo data-id="element-1105" data-mp="2gy8431tydagn" />
        </div>
      </div>

      <div className="mt-20 grid gap-14 lg:grid-cols-12" data-id="element-1106" data-mp="2h018sbl09km0">
        <div className="lg:col-span-7" data-id="element-1107" data-mp="2cwd17swdip0r">
          <h3 className="text-[20px] font-semibold text-ink" data-id="element-1108" data-mp="2cvbgsxtgwq6d">Tijden en curves</h3>
          <p className="mt-1 text-[15px] text-ink-muted" data-id="element-1109" data-mp="27ykz6620lmiu">Eén element duurt nooit langer dan 300 ms. Continue beweging volgt echte voortgang.</p>
          <div className="mt-6 overflow-x-auto" data-id="element-1110" data-mp="2311n9csshlu2">
            <table className="w-full min-w-[520px] text-left" data-id="element-1111" data-mp="30lfi2yj6odu7">
              <thead data-id="element-1112" data-mp="2vnmca6lsllug">
                <tr className="border-b border-white/[0.08] text-[13px] text-ink-muted" data-id="element-1113" data-mp="2vn48mowsw5ci">
                  <th scope="col" className="py-3 pr-4 font-medium" data-id="element-1114" data-mp="2qw48zbwar96b">Moment</th>
                  <th scope="col" className="py-3 pr-4 font-medium" data-id="element-1115" data-mp="2lxkn1bhpdxdy">Waarde</th>
                  <th scope="col" className="py-3 font-medium" data-id="element-1116" data-mp="2lvglh07a1agu">Detail</th>
                </tr>
              </thead>
              <tbody data-id="element-1117" data-mp="3em8drml81eyw">
                {motionTokens.map(t => <tr key={t.name} className="border-b border-white/[0.05] align-top" data-id="element-1118" data-mp="3ekxarozlob8u">
                    <th scope="row" className="whitespace-nowrap py-3.5 pr-4 text-[15px] font-medium text-ink" data-id="element-1119" data-mp="1cp7yn4xibgjo">{t.name}</th>
                    <td className="whitespace-nowrap py-3.5 pr-4 text-[15px] tabular-nums text-accent" data-id="element-1120" data-mp="1gsdzty5rihja">{t.value}</td>
                    <td className="py-3.5 text-[14px] leading-snug text-ink-soft" data-id="element-1121" data-mp="17xzp88w6fv6i">{t.detail}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        <div className="lg:col-span-5" data-id="element-1122" data-mp="xzs6plm8p52e">
          <h3 className="text-[20px] font-semibold text-ink" data-id="element-1123" data-mp="y0l8s9a976e7">Data die verandert</h3>
          <p className="mb-6 mt-1 text-[15px] text-ink-muted" data-id="element-1124" data-mp="k0snwulerke5">Tellers rollen, voortgang vult, grafieken tekenen.</p>
          <LiveDataDemo data-id="element-1125" data-mp="ozwt7a57oxz7" />
        </div>
      </div>
    </SpecSection>;
}